import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HStack, Icon, Text } from "@chakra-ui/react";
import { IoFolderOutline } from "react-icons/io5";
import React from "react";
const FolderBadge = ({ showIcon = true, children, }) => (_jsxs(HStack, Object.assign({ spacing: "1", color: "gray.500", backgroundColor: "gray.100", px: "1", borderRadius: "2px" }, { children: [showIcon && _jsx(Icon, { as: IoFolderOutline, boxSize: "16px" }), _jsx(Text, Object.assign({ fontSize: "xs" }, { children: children }))] })));
export default FolderBadge;
